import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myArrayReverse',
  pure: false
})
export class ArrayReversePipe implements PipeTransform {

  transform(values) {
    if (values) {
      return values.slice().reverse();
    }
  }
}
